import {
  defaultGapping,
  defaultLayouts,
  defaultTypography,
  GSSelect,
} from "golfstatus_react_components";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTime } from "../../helpers/Dates";
import { getRoundName } from "../../hooks/roundHooks";
import {
  getRoundHoleAssignments,
  getTournamentRound,
} from "../../reducers/tournamentSlice";
import { selectRegistrationOrder } from "../../reducers/registrationOrderSlice";

const HoleAssignmentSelectWidget = (props) => {
  const { holeAssignment, onChange } = props;

  const roundID = holeAssignment?.tournamentRound?.id;

  const [roundHoleAssignments, setRoundHoleAssignments] = useState([]);
  const [round, setRound] = useState({});
  const registrationOrder = useSelector(selectRegistrationOrder);

  const allTeams = useMemo(() => {
    return registrationOrder?.registrationOrderItems?.flatMap(
      (oi) => oi.inProgressTournamentTeams
    );
  }, [registrationOrder]);

  const currentAssignments = useMemo(() => {
    return allTeams?.flatMap?.(
      (t) => t?.inProgressTournamentTeamsRoundHoleAssignments
    );
  }, [allTeams]);

  const holeAssignmentIsAvailable = (ha) => {
    let current = 0
    if (ha.availableTeams > 0) {
      const currentSelections = currentAssignments?.filter?.(
        (a) => a?.roundHoleAssignment?.id === ha.id && holeAssignment?.roundHoleAssignment?.id !== ha.id
      );
      current = currentSelections.length 
    }
    return ha.availableTeams > current;
  };

  const holeAssignmentOptions = roundHoleAssignments
    ?.filter?.((ha) => holeAssignmentIsAvailable(ha))
    ?.map?.((ha) => {
      return {
        label: `hole ${ha.hole} - ${ha.position}${ha.subPosition ??
          ""} : ${getTime(ha.teeTime)}`,
        value: ha,
      };
    });

  const selectedHoleAssignment = holeAssignmentOptions?.find?.((ha) => {
    return ha.value?.id === holeAssignment?.roundHoleAssignment?.id;
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (roundID) {
      dispatch(getRoundHoleAssignments(roundID))?.then?.((response) => {
        setRoundHoleAssignments(response?.payload ?? []);
      });
      dispatch(getTournamentRound(roundID))?.then?.((response) => {
        setRound(response.payload);
      });
    }
  }, [dispatch, roundID]);

  return (
    <hole-assignment-select-widget
      style={{ ...defaultLayouts.vStack, ...defaultGapping.mediumGap }}
    >
      <div
        style={{ ...defaultTypography.bodyRegular.withOpacity() }}
      >{getRoundName(round)}</div>
      <GSSelect
        options={holeAssignmentOptions}
        onChange={onChange}
        selectedOption={selectedHoleAssignment}
      />
    </hole-assignment-select-widget>
  );
};

export default HoleAssignmentSelectWidget;
